import { render, staticRenderFns } from "./history.pug?vue&type=template&id=07e8afeb&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./history.scss?vue&type=style&index=0&id=07e8afeb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e8afeb",
  null
  
)

export default component.exports